// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"f674946d","911":"fe014500"}[chunkId] + ".chunk.css";
};